<template>
<v-container fluid>
  <v-form ref="form">
    <CheckBox  
    :label="$t('Использовать телеграм бота')" 
    :hint="$t('Заказы оформленные онлайн будут отправляться в чат')" 
    :original_value="config.enabled" 
    :disabled="disabled"
    v-model="local_config.enabled"/>
    
    <TextField 
      :loading="any_loading"
      :label="`${$t('Токен телеграм бота')}`"
      :hint="$t('Токен необходимо скопировать при создании бота или в личном кабинете BotFather')"
      :disabled="disabled || !local_config.enabled"
      :original_value="config.token_bot"
      v-model="local_config.token_bot"
    />
    
    <TextField 
      :loading="any_loading"
      :label="`${$t('ID чата для оповещений')}`"
      :hint="`${$t('ID чата в который необходимо отправлять уведомления из заказов в магазине')}`"
      :disabled="disabled || !local_config.enabled"
      :original_value="config.chat_id"
      v-model="local_config.chat_id"
    />
  </v-form>
</v-container>
</template>

<script>
import TextField from '../../../common/TextField.vue'
import CheckBox from '../../../common/CheckBox.vue'
import settings_group_mixin from '../../settings_group_mixin'

export default {
  mixins: [settings_group_mixin],
  props: {
    disabled: Boolean
  },
  data: () => ({
    local_loading: false,
    locales: [],

  }),
  computed: {
    any_loading() {
      return this.local_loading || this.local_loading
    }
  },
  methods: {
    validate(){
      if (this.local_config.enabled) {

        if (!this.local_config.token_bot) {
          throw new Error(this.$t('Укажите токен телеграм бота'))
        }

        if (!this.local_config.chat_id) {
          throw new Error(this.$t('Укажите ID чата'))
        }

      }
    },
    async loadLocales(){
      this.local_loading = true
      try {
        this.locales = await this.$store.dispatch('getAvailableLocales')
      } finally {
        this.local_loading = false
      }
    },
    // validate(){
    //   if (!this.$refs.form.validate()) {
    //     throw new Error(this.$t('Проверьте корректность веденных настроек перед сохранением изменений'))
    //   }
    // }
  },
  mounted(){
    this.loadLocales()
  },
  components: {
    TextField,
    CheckBox
  }
}
</script>